export default "__VITE_ASSET__Ch8V5YCJ__"